/**
 * 모바일 관리자 — 불러톡 방 목록.
 *
 * 방(카드)을 누르면 대화창, 프사(회원 아이콘)를 누르면 기사 상세 시트다 — 상담 전에
 * "이 사람이 누구인가"를 보려고 기사관리까지 다녀오지 않게 한다.
 *
 * 대화창은 이 모듈이 그리지 않는다. 방을 누르면 /ma/chat/room 으로 이동하고,
 * 거기서 /m·/adm 과 같은 공유 하네스($j.F.Chat + mobile/pages/chat/chatRoom)가 화면을 잡는다.
 * (사진첨부·음성·삭제·빠른답변·소켓 실시간이 그쪽에 다 들어 있다)
 */
import { openDriverSheet } from './driverSheet';
import { saveListReturn, takeListReturn, restoreScroll } from './listReturn';

export default class Chat {
    initialize() {
        this.$roomList = $('#maChatRoomList');
        this.$empty   = $('#maChatEmpty');
        this.$loading = $('#maChatLoading');

        this.bind();

        // 대화창에서 돌아온 자리 — 검색어를 되살려 같은 목록을 그리고 보던 위치로 내린다
        const back = takeListReturn('chat');
        if (back) $('#maChatSearch').val(back.q || '');
        this.loadRooms(back ? () => restoreScroll(back.y) : null);
    }

    bind() {
        $('#maChatSearchBtn').on('click', () => this.loadRooms());
        $('#maChatSearch').on('keydown', (e) => { if (e.key === 'Enter') this.loadRooms(); });

        // 프사 → 기사 상세 시트 (방번호 = 회원번호). 카드 클릭(대화창)으로 번지지 않게 막는다
        this.$roomList.on('click', '.ma-room-ava', (e) => {
            e.stopPropagation();
            openDriverSheet(+$(e.currentTarget).data('mem'), { back: '/ma/chat' });
        });
        this.$roomList.on('click', '.ma-room', (e) => {
            this.openRoom(+$(e.currentTarget).data('room'));
        });
    }

    /** 대화창으로 이동 — 방번호 = 회원번호 */
    openRoom(room) {
        const n = parseInt(room, 10) || 0;
        if (!n) return;
        saveListReturn('chat', { q: ($('#maChatSearch').val() || '').trim() });
        location.replace(`/ma/chat/room?rno=${n}`);
    }

    /** @param {Function} [after] 목록을 다 그린 뒤 1회 (복귀 시 스크롤 복원) */
    loadRooms(after) {
        this.$loading.prop('hidden', false);
        this.$empty.prop('hidden', true);
        this.$roomList.empty();
        const q = ($('#maChatSearch').val() || '').trim();

        $.getJSON('/ma/ajax/chat/rooms', { q })
            .done((res) => {
                const list = (res && res.list) || [];
                list.forEach((r) => this.$roomList.append(this.roomHtml(r)));
                this.$empty.prop('hidden', list.length !== 0);
                if (typeof after === 'function') after();
            })
            .fail((xhr) => this.toast(xhr.status === 401 ? '세션이 만료되었습니다' : '목록을 불러오지 못했습니다'))
            .always(() => this.$loading.prop('hidden', true));
    }

    roomHtml(r) {
        const unread = +r.unread_count || 0;
        const time = (r.sent_date || '').slice(5, 16); // MM-DD HH:MM
        const ava = r.profile_img
            ? `<img src="${this.esc(r.profile_img)}" alt="">`
            : `<span class="ma-room-ini">${this.esc((r.mem_name || '?').slice(0, 1))}</span>`;

        // 카드는 div 다 — 안에 프사 버튼이 들어가므로 (버튼 안 버튼은 안 된다). 기사카드와 같은 골격.
        return `<div class="ma-room" data-room="${r.room_num}">
            <button type="button" class="ma-room-ava" data-mem="${r.room_num}" aria-label="기사 상세">${ava}</button>
            <span class="ma-room-main">
                <span class="ma-room-top"><b>${this.esc(r.showName || r.mem_name || '')}</b><span class="ma-room-code">#${r.room_num}</span></span>
                <span class="ma-room-preview">${this.esc(r.content || '')}</span>
            </span>
            <span class="ma-room-side">
                <span class="ma-room-time">${this.esc(time)}</span>
                ${unread ? `<span class="ma-room-unread">${unread > 99 ? '99+' : unread}</span>` : ''}
            </span>
        </div>`;
    }

    toast(msg) { if ($j.Ui && $j.Ui.Toast) $j.Ui.Toast.show(msg); }

    esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
